<!-- One card, no boxes inside it (#5522): the offered meal is the first row and the other recent
     meals are rows under it, split by divider lines. The section's title and its View All button
     live in the ingredient list's header row, not here. -->
<div class="recent-meals-wrapper">
  @if (recentMealsLoading) {
    <div class="recent-meals-loading">
      <cs-spinner></cs-spinner>
    </div>
  } @else {
    <!-- The meal the user most likely came to repeat: their own last meal in THIS slot.
         Its button logs the whole meal in one tap and offers Undo, rather than opening
         the confirmation screen every other route into a recent meal opens. -->
    @if (repeatHero) {
      <div class="repeat-hero">
        <span class="repeat-hero-label">{{ LL.ingredientSearch.repeatMeal.lastTimeIn({ meal: currentMealName }) }}</span>
        <span class="repeat-hero-name">{{ repeatHero.name }}</span>
        @if (repeatHero.description) {
          <span class="repeat-hero-foods">{{ repeatHero.description }}</span>
        }
        @if (repeatHeroNutrients.length) {
          <nutrient-list [nutrients]="repeatHeroNutrients" state="inline-compact" [expandable]="false"
            [hideLabel]="true"></nutrient-list>
        }
        <!-- outlined, not filled: the one-tap repeat must not outrank the add routes above it -->
        <cs-button secondary icon="add" id="repeatLastMeal" (click)="repeatMeal.emit(repeatHero)">
          {{ LL.ingredientSearch.repeatMeal.add() }}
        </cs-button>
      </div>
    }
    @if (otherRecentMeals.length > 0) {
      <div class="recent-meals-list">
        @for (meal of otherRecentMeals; track meal._id) {
          <div class="recent-meal-row" (click)="onOpenMeal(meal)">
            <div class="recent-meal-info">
              <span class="recent-meal-name">{{ meal.name }}</span>
              <span class="recent-meal-description">{{ meal.description }}</span>
            </div>
            <cs-icon-button outlined icon="add" (click)="onOpenMeal(meal, $event)"></cs-icon-button>
          </div>
        }
      </div>
    }
  }
</div>
